const colors = {
  hex: {
    primary_400: "6ea618",
    primary: "7eb628",
    dark: "5c5c60",
  },
};

export default colors;
